// "Shared the stage with" on a public profile (issue #41 phase 3). Public, no
// login. Shapes mirror `services/scenePolicy.ts` PlayedTogether.
import axios from 'axios';
import { getApiBaseUrl } from './apiConfig';

export interface PlayedTogetherItem {
  type: 'performer' | 'venue';
  id: string;
  name: string;
  picture: string | null;
  /** How many completed shows together. Never which. */
  shows: number;
}

export interface PlayedTogetherResult {
  items: PlayedTogetherItem[];
  total: number;
}

export const playedTogetherApi = {
  async get(entityType: 'performer' | 'venue', entityId: string): Promise<PlayedTogetherResult> {
    const res = await axios.get(`${getApiBaseUrl()}/api/played-together/${entityType}/${entityId}`);
    return { items: res.data.items ?? [], total: res.data.total ?? 0 };
  },
};

export default playedTogetherApi;
